export enum VisitStatus {
	Unknown = 'unknown',
	Visited = 'visited',
	NotVisited = 'notVisited',
}
